import { render, staticRenderFns } from "./PlaceCustomerOrder.vue?vue&type=template&id=3e645017&"
import script from "./PlaceCustomerOrder.vue?vue&type=script&lang=js&"
export * from "./PlaceCustomerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports